import * as React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Header from "./components/layout/Header";
import Sidebar from "./components/layout/Sidebar";
import Dashboard from "./pages/Dashboard";
import Setup from "./pages/Setup";
import SharePointConfig from "./pages/SharePointConfig";
import KnowledgeBase from "./pages/KnowledgeBase";
import TriggerConfig from "./pages/TriggerConfig";
import ActivityLogs from "./pages/ActivityLogs";
import HelpSupport from "./pages/HelpSupport";

// Import AppData
import AppData from "./data/AppData";
import GlobalAuthenticatedContext from "./components/common/contexts/GlobalAuthenticatedContexts";
import GlobalAuthenticatedContextModel from "./components/common/contexts/GlobalAuthenticatedContextModel";
import "./index.css";
import RouteWrapper from "./components/routing/RouterWrapper";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RoleConstants } from './components/common/utilities/appConstants'
import ReleaseNotes from "./pages/ReleaseNotes";
const OAuthCallbackPage = React.lazy(() => import("./pages/OAuthCallback"));
const PopupLogin = React.lazy(() => import("./pages/login/PopUpLogin"));
const LoginPage = React.lazy(() => import("./pages/login/GenesysCloudLogin"));
const UnauthorizedPage = React.lazy(() => import("./pages/Unauthorized"));
const App = () => {
  const [globalAuthenticated, setGlobalAuthenticated] = React.useState(
    GlobalAuthenticatedContextModel
  );

  const installed = globalAuthenticated.installed;
  console.log("installed", installed);
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  const [setupCompleted, setSetupCompleted] = React.useState(installed);
  const [userRole, setUserRole] = React.useState<string>("admin");    

  const LazyLoadedRoutesFallback = () => {
    return <div>loading...</div>;
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Debug authentication state
  React.useEffect(() => {
    console.log('globalAuthenticated:', globalAuthenticated);
  }, [globalAuthenticated]);

  const allowedRoles = [RoleConstants.admin, RoleConstants.sharepointAdmin, RoleConstants.sharepointView];
  const userRoles = globalAuthenticated?.userRoles || [];

  const isAuthorized = userRoles.some((role: any) =>
    allowedRoles.includes(role.name)
  );

  return (
    <Router>
      <GlobalAuthenticatedContext.Provider
        value={{ globalAuthenticated, setGlobalAuthenticated }}
      >
        <React.Suspense fallback={<LazyLoadedRoutesFallback />}>
          <div className="h-full bg-gray-100">
            {/* <LayoutWrapper> */}
            { globalAuthenticated.contextLoaded && (isAuthorized || (!installed && 
            globalAuthenticated.integrationFound && 
            window.location.pathname === '/setup')) && (
              <>
                <Sidebar
                  sidebarOpen={sidebarOpen}
                  toggleSidebar={toggleSidebar}
                  setupCompleted={installed}
                  navigation={AppData.navigation}
                  userRole={userRole}
                  setUserRole={setUserRole}
                />
                <Header />
              </>
            )}
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                style={{
                  top: '5rem', // Account for the header
                  right: '1rem'
                }}
                toastStyle={{
                  fontSize: '14px',
                  borderRadius: '0.5rem',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                }}
              />
              <Routes>
                <Route
                  path="/help"
                  element={<HelpSupport /> }
                />
                <Route path="/" element={<RouteWrapper />}>
                  <Route
                    path="/"
                    element={
                      globalAuthenticated.contextLoaded ? (
                        <Dashboard setupCompleted={installed} />
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />
                  <Route
                    path="/setup"
                    element={
                      globalAuthenticated.contextLoaded ? (
                        <Setup
                          setupCompleted={setupCompleted}
                          setSetupCompleted={setSetupCompleted}
                        />
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />
                  <Route
                    path="/sharepoint"
                    element={
                      globalAuthenticated.contextLoaded ? (
                        installed ? (
                          <SharePointConfig />
                        ) : (
                          <Navigate to="/setup" replace />
                        )
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />
                  <Route
                    path="/knowledge-base"
                    element={
                      globalAuthenticated.contextLoaded ? (
                        installed ? (
                          <KnowledgeBase />
                        ) : (
                          <Navigate to="/setup" replace />
                        )
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />
                  <Route
                    path="/trigger-config"
                    element={
                      globalAuthenticated.contextLoaded ? (
                        installed ? (
                          <TriggerConfig />
                        ) : (
                          <Navigate to="/setup" replace />
                        )
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />
                  <Route
                    path="/logs"
                    element={
                      globalAuthenticated.contextLoaded ? (
                        <ActivityLogs />
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />
                  <Route
                    path="/releasenotes"
                    element={
                      globalAuthenticated.contextLoaded ? (
                        <ReleaseNotes />
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />
                  
                </Route>
                <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/popuplogin" element={<PopupLogin />} />
                  <Route path="/unauthorized" element={<UnauthorizedPage />} />

                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes> 
          </div>
        </React.Suspense>
      </GlobalAuthenticatedContext.Provider>
    </Router>
  );

}
export default App;